// ============================================
// 文件: src/api/reports.js
// 举报管理 API
// ============================================
import request from '../utils/request';

// 获取举报列表
export const getReportList = (params) => {
  return request({
    url: '/api/vincent/reports',
    method: 'GET',
    params
  });
};

// 获取举报详情
export const getReportDetail = (reportId) => {
  return request({
    url: `/api/vincent/reports/${reportId}`,
    method: 'GET'
  });
};

// 处理举报
export const handleReport = (reportId, data) => {
  return request({
    url: `/api/vincent/reports/${reportId}/handle`,
    method: 'PUT',
    data
  });
};

// 批量处理举报
export const batchHandleReports = (data) => {
  return request({
    url: '/api/vincent/reports/batch-handle',
    method: 'POST',
    data
  });
};

// 获取举报统计
export const getReportStats = () => {
  return request({
    url: '/api/vincent/reports/stats',
    method: 'GET'
  });
};
